module.exports = __webpack_public_path__ + "static/media/pokemon-theme-song.f3b60c4b.mp3";